(function () {
  'use strict';

  var loaderScript = document.currentScript;

  if (!loaderScript || window.__lara11ClerkRecommendationsLoaded) {
    return;
  }

  window.__lara11ClerkRecommendationsLoaded = true;

  var clerkKey = loaderScript.dataset.clerkKey;
  var locale = loaderScript.dataset.clerkLocale || document.documentElement.lang || 'it-IT';
  var currency = loaderScript.dataset.clerkCurrency || 'EUR';
  var currencySymbol = loaderScript.dataset.clerkCurrencySymbol || '€';
  var showCurrencyCode = loaderScript.dataset.clerkCurrencyCodeEnabled === 'true';
  var isDesignMode = loaderScript.dataset.designMode === 'true' || Boolean(window.Shopify && window.Shopify.designMode);

  function getClerkVisitor() {
    if (!window.Lara11ClerkPrivacy || typeof window.Lara11ClerkPrivacy.getVisitor !== 'function') {
      return null;
    }

    return window.Lara11ClerkPrivacy.getVisitor();
  }

  function loadClerk() {
    if (window.Clerk) {
      return;
    }

    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://cdn.clerk.io/clerk.js';

    var firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode.insertBefore(script, firstScript);

    window.__clerk_q = window.__clerk_q || [];
    window.Clerk = window.Clerk || function () {
      window.__clerk_q.push(arguments);
    };
  }

  function toArray(value) {
    return Array.isArray(value) ? value : [];
  }

  function shuffleProducts(products) {
    var shuffledProducts = products.slice();

    for (var index = shuffledProducts.length - 1; index > 0; index -= 1) {
      var randomIndex = Math.floor(Math.random() * (index + 1));
      var currentProduct = shuffledProducts[index];
      shuffledProducts[index] = shuffledProducts[randomIndex];
      shuffledProducts[randomIndex] = currentProduct;
    }

    return shuffledProducts;
  }

  function getPreviewProducts(root) {
    var previewData = root.querySelector('[data-clerk-preview-products]');

    if (!previewData) {
      return [];
    }

    try {
      return toArray(JSON.parse(previewData.textContent));
    } catch (error) {
      return [];
    }
  }

  function getProducts(data) {
    if (!data || !data.product_data) {
      return [];
    }

    if (Array.isArray(data.product_data)) {
      return data.product_data;
    }

    if (typeof data.product_data !== 'object') {
      return [];
    }

    var resultIds = toArray(data.result);

    if (resultIds.length > 0) {
      return resultIds
        .map(function (id) {
          return data.product_data[id] || data.product_data[String(id)];
        })
        .filter(Boolean);
    }

    return Object.keys(data.product_data).map(function (key) {
      return data.product_data[key];
    });
  }

  function safeUrl(value) {
    if (!value) {
      return '';
    }

    try {
      var url = new URL(value, window.location.origin);

      if (url.protocol === 'http:' || url.protocol === 'https:') {
        return url.href;
      }
    } catch (error) {
      return '';
    }

    return '';
  }

  function formatPrice(value) {
    var price = Number(value);

    if (!Number.isFinite(price)) {
      return '';
    }

    var currencyRate = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        currencyDisplay: showCurrencyCode ? 'code' : 'symbol'
      }).format(price * currencyRate);
    } catch (error) {
      return (price * currencyRate).toFixed(2) + ' ' + currency;
    }
  }

  function createBadge(product) {
    var price = Number(product.price);
    var listPrice = Number(product.list_price);

    if (!Number.isFinite(price) || !Number.isFinite(listPrice) || listPrice <= price) {
      return null;
    }

    var badgeList = document.createElement('div');
    badgeList.className = 'badge-list';

    var badge = document.createElement('span');
    badge.className = 'badge badge--on-sale';
    badge.textContent = '-' + Math.round((1 - price / listPrice) * 100) + '%';
    badgeList.appendChild(badge);

    return badgeList;
  }

  function createPriceList(product, root) {
    var price = Number(product.price);
    var listPrice = Number(product.list_price);
    var isOnSale = Number.isFinite(price) && Number.isFinite(listPrice) && listPrice > price;
    var priceList = document.createElement('price-list');
    priceList.className = 'price-list';

    var salePrice = document.createElement('sale-price');
    salePrice.className = (root.dataset.productTitleFont === 'heading' ? 'h6 ' : '') + (isOnSale ? 'text-on-sale' : 'text-subdued');
    salePrice.textContent = formatPrice(product.price);
    priceList.appendChild(salePrice);

    if (isOnSale && root.dataset.showComparePrice === 'true') {
      var compareAtPrice = document.createElement('compare-at-price');
      compareAtPrice.className = (root.dataset.productTitleFont === 'heading' ? 'h6 ' : '') + 'text-subdued line-through';
      compareAtPrice.textContent = formatPrice(product.list_price);
      priceList.appendChild(compareAtPrice);
    }

    return priceList;
  }

  function createProductCard(product, position, root) {
    var productUrl = safeUrl(product.url);
    var imageUrl = safeUrl(product.image);
    var productName = product.name || product.title || '';
    var productId = product.id == null ? '' : String(product.id);
    var card = document.createElement('article');
    card.className = 'product-card clerk-recommendations__card';
    card.dataset.clerkProductId = productId;

    var figure = document.createElement('div');
    figure.className = 'product-card__figure';

    if (root.dataset.showSaleBadge === 'true') {
      var badge = createBadge(product);

      if (badge) {
        figure.appendChild(badge);
      }
    }

    var mediaLink = document.createElement('a');
    mediaLink.className = 'product-card__media';
    mediaLink.href = productUrl || '#';
    mediaLink.dataset.instant = '';

    if (imageUrl) {
      var image = document.createElement('img');
      image.className = 'product-card__image product-card__image--primary clerk-recommendations__image';

      if (root.dataset.imageAspect !== 'natural') {
        image.classList.add('aspect-' + root.dataset.imageAspect);
      }

      if (root.dataset.imageFit === 'cover') {
        image.classList.add('object-cover');
      }

      image.src = imageUrl;
      image.alt = productName;
      image.loading = position < 3 ? 'eager' : 'lazy';
      image.decoding = 'async';
      image.draggable = false;
      mediaLink.appendChild(image);
    }

    figure.appendChild(mediaLink);
    card.appendChild(figure);

    var info = document.createElement('div');
    info.className = 'product-card__info';

    var outerStack = document.createElement('div');
    outerStack.className = 'v-stack justify-items-center gap-2';
    var vendor = product.brand || product.vendor;

    if (vendor && root.dataset.showVendor === 'true') {
      var vendorElement = document.createElement('p');
      vendorElement.className = 'smallcaps text-subdued' + (root.dataset.productTitleFont === 'heading' ? ' heading' : '');
      vendorElement.textContent = vendor;
      outerStack.appendChild(vendorElement);
    }

    var detailsStack = document.createElement('div');
    detailsStack.className = 'v-stack justify-items-center gap-1';

    var title = document.createElement('a');
    title.className = 'product-title' + (root.dataset.productTitleFont === 'heading' ? ' h6' : '');
    title.href = productUrl || '#';
    title.dataset.instant = '';
    title.textContent = productName;
    detailsStack.appendChild(title);
    detailsStack.appendChild(createPriceList(product, root));
    outerStack.appendChild(detailsStack);
    info.appendChild(outerStack);
    card.appendChild(info);

    return card;
  }

  function parseJsonData(value) {
    if (!value) {
      return [];
    }

    try {
      return toArray(JSON.parse(value));
    } catch (error) {
      return [];
    }
  }

  function isProductAvailable(product) {
    var availability = product.available;

    if (availability == null) {
      availability = product.in_stock;
    }

    if (availability == null) {
      return true;
    }

    if (typeof availability === 'string') {
      return !['false', '0', 'no', 'out_of_stock', 'out of stock'].includes(availability.toLowerCase());
    }

    return Boolean(availability);
  }

  function prepareCartProducts(root, products) {
    var cartProductIds = new Set(
      parseJsonData(root.dataset.cartProductIds).map(function (id) {
        return String(id);
      })
    );
    var seenProductIds = new Set();
    var maxProducts = Math.max(1, Number(root.dataset.maxProducts) || 4);

    return products
      .filter(function (product) {
        var productId = product.id == null ? '' : String(product.id);

        if (!productId || cartProductIds.has(productId) || seenProductIds.has(productId) || !isProductAvailable(product)) {
          return false;
        }

        seenProductIds.add(productId);
        return true;
      })
      .slice(0, maxProducts);
  }

  function getProductHandle(value) {
    var productUrl = safeUrl(value);

    if (!productUrl) {
      return '';
    }

    try {
      var pathSegments = new URL(productUrl).pathname.split('/').filter(Boolean);
      var productsIndex = pathSegments.lastIndexOf('products');

      return productsIndex >= 0 ? pathSegments[productsIndex + 1] || '' : '';
    } catch (error) {
      return '';
    }
  }

  function safeIdPart(value) {
    return String(value || '').replace(/[^a-zA-Z0-9_-]/g, '-');
  }

  function replaceLabelToken(value, token, replacement) {
    return String(value || '').replace(token, replacement);
  }

  function createCartQuickBuyButton(modalId, label, isLarge) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = isLarge
      ? '@large:horizontal-product-card__button button button--outline button--subdued'
      : '@narrow:horizontal-product-card__button link';
    button.setAttribute('aria-controls', modalId);
    button.textContent = label;
    return button;
  }

  function createCartProductCard(product, position, root) {
    var productUrl = safeUrl(product.url);
    var imageUrl = safeUrl(product.image);
    var productName = product.name || product.title || '';
    var productId = product.id == null ? '' : String(product.id);
    var card = document.createElement('div');
    card.className = 'horizontal-product-card clerk-cart-recommendations__card';
    card.dataset.clerkProductId = productId;

    if (imageUrl) {
      var mediaLink = document.createElement('a');
      mediaLink.className = 'horizontal-product-card__figure';
      mediaLink.href = productUrl || '#';
      mediaLink.dataset.instant = '';

      var image = document.createElement('img');
      image.className = 'horizontal-product-card__image clerk-cart-recommendations__image';
      image.src = imageUrl;
      image.alt = productName;
      image.loading = position === 0 ? 'eager' : 'lazy';
      image.decoding = 'async';
      image.draggable = false;
      mediaLink.appendChild(image);
      card.appendChild(mediaLink);
    }

    var info = document.createElement('div');
    info.className = 'horizontal-product-card__info';

    var details = document.createElement('div');
    details.className = 'v-stack gap-1 justify-items-start';

    var title = document.createElement('a');
    title.className = 'product-title' + (root.dataset.productTitleFont === 'heading' ? ' h6' : '');
    title.href = productUrl || '#';
    title.dataset.instant = '';
    title.textContent = productName;
    details.appendChild(title);

    if (root.dataset.showPrice === 'true') {
      details.appendChild(createPriceList(product, root));
    }

    info.appendChild(details);

    var productHandle = getProductHandle(productUrl);

    if (root.dataset.showQuickBuy === 'true' && productHandle) {
      var modalId =
        'clerk-cart-quick-buy-' + safeIdPart(root.dataset.sectionId) + '-' + safeIdPart(productId || position);
      var modal = document.createElement('quick-buy-modal');
      modal.id = modalId;
      modal.setAttribute('handle', productHandle);
      modal.className = 'quick-buy-modal modal modal--lg color-scheme color-scheme--dialog';
      modal.setAttribute(
        'aria-label',
        replaceLabelToken(root.dataset.quickBuyAriaLabel, '__PRODUCT_TITLE__', productName)
      );
      modal.textContent = 'LOADING';
      info.appendChild(modal);

      var addToCartLabel = root.dataset.addToCartLabel || 'Add to cart';
      info.appendChild(createCartQuickBuyButton(modalId, addToCartLabel, false));
      info.appendChild(createCartQuickBuyButton(modalId, addToCartLabel, true));
    }

    card.appendChild(info);
    return card;
  }

  function getCartHeading(root, data, content) {
    if (root.dataset.headingMode === 'hidden') {
      return '';
    }

    if (root.dataset.headingMode !== 'clerk') {
      return root.dataset.heading || '';
    }

    if (data && data.headline) {
      return data.headline;
    }

    return content && typeof content.param === 'function' ? content.param('headline') || '' : '';
  }

  function createCartNavigation(root, carouselId, productsCount) {
    if (root.dataset.layout !== 'carousel' || productsCount < 2) {
      return null;
    }

    var navigation = document.createElement('carousel-navigation');
    navigation.className = 'page-dots page-dots--narrow';
    navigation.setAttribute('aria-controls', carouselId);

    for (var index = 0; index < productsCount; index += 1) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'relative';
      button.setAttribute('aria-current', index === 0 ? 'true' : 'false');

      var label = document.createElement('span');
      label.className = 'sr-only';
      label.textContent = replaceLabelToken(root.dataset.pageDotAriaLabel, '__INDEX__', String(index + 1));
      button.appendChild(label);
      navigation.appendChild(button);
    }

    return navigation;
  }

  function createCartHeader(root, data, content, navigation) {
    var heading = getCartHeading(root, data, content);

    if (!heading && !navigation) {
      return null;
    }

    var header = document.createElement('div');
    header.className = 'complementary-products__header complementary-products__header--align-start';

    if (heading) {
      var title = document.createElement('p');
      title.className = 'h6';
      title.textContent = heading;
      header.appendChild(title);
    } else {
      header.classList.add('clerk-cart-recommendations__header--navigation-only');
    }

    if (navigation) {
      header.appendChild(navigation);
    }

    return header;
  }

  function createCartProductList(root, products, carouselId) {
    var cards = products.map(function (product, position) {
      return createCartProductCard(product, position, root);
    });

    if (root.dataset.layout === 'stack') {
      var stack = document.createElement('div');
      stack.className = 'complementary-products__product-list';
      stack.append.apply(stack, cards);
      return stack;
    }

    var template = root.querySelector('template[data-clerk-cart-carousel-template]');

    if (!template) {
      var fallbackStack = document.createElement('div');
      fallbackStack.className = 'complementary-products__product-list';
      fallbackStack.append.apply(fallbackStack, cards);
      return fallbackStack;
    }

    var fragment = template.content.cloneNode(true);
    var carousel = fragment.querySelector('scroll-carousel');
    carousel.id = carouselId;
    carousel.append.apply(carousel, cards);
    return fragment;
  }

  function renderCartProducts(root, products, data, content, trackClicks) {
    var output = root.querySelector('[data-clerk-recommendations-output]');
    var cartProducts = prepareCartProducts(root, products);

    if (!output || cartProducts.length === 0) {
      root.hidden = true;
      return;
    }

    var carouselId = 'clerk-cart-recommendations-carousel-' + safeIdPart(root.dataset.sectionId);
    var navigation = createCartNavigation(root, carouselId, cartProducts.length);
    var header = createCartHeader(root, data, content, navigation);
    var productList = createCartProductList(root, cartProducts, carouselId);

    // Dynamic custom elements connect as soon as they enter the document. The
    // carousel must therefore exist before carousel-navigation is inserted.
    output.replaceChildren(productList);

    if (header) {
      output.prepend(header);
    }

    root.hidden = false;

    if (trackClicks) {
      window.Clerk('click', '#' + output.id + ' [data-clerk-product-id]');
    }
  }

  function createHeader(root, data, content) {
    var headingMode = root.dataset.headingMode;

    if (headingMode === 'hidden') {
      return null;
    }

    var heading = root.dataset.heading || '';

    if (headingMode === 'clerk') {
      heading = data && data.headline ? data.headline : '';

      if (!heading && content && typeof content.param === 'function') {
        heading = content.param('headline') || '';
      }
    }

    var subheading = root.dataset.subheading || '';

    if (!heading && !subheading) {
      return null;
    }

    var alignment = root.dataset.headerAlignment || 'center';

    if (alignment === 'left') {
      alignment = 'start';
    } else if (alignment === 'right') {
      alignment = 'end';
    } else if (alignment !== 'start' && alignment !== 'end') {
      alignment = 'center';
    }

    var header = document.createElement('div');
    header.className = 'section-header clerk-recommendations__header text-' + alignment;

    var prose = document.createElement('div');
    prose.className = 'prose';

    if (subheading) {
      var eyebrow = document.createElement('p');
      eyebrow.className = 'h6';
      eyebrow.textContent = subheading;
      prose.appendChild(eyebrow);
    }

    if (heading) {
      var title = document.createElement('h2');
      title.className = root.dataset.headingStyle || 'h2';
      title.textContent = heading;
      prose.appendChild(title);
    }

    header.appendChild(prose);
    return header;
  }

  function createProductList(root, products) {
    var cards = products.map(function (product, position) {
      return createProductCard(product, position, root);
    });

    if (root.dataset.layout === 'grid') {
      var grid = document.createElement('product-list');
      grid.className = 'product-list justify-center';
      grid.append.apply(grid, cards);
      return grid;
    }

    var template = root.querySelector('template[data-clerk-carousel-template]');

    if (!template) {
      var fallbackGrid = document.createElement('product-list');
      fallbackGrid.className = 'product-list justify-center';
      fallbackGrid.append.apply(fallbackGrid, cards);
      return fallbackGrid;
    }

    var fragment = template.content.cloneNode(true);
    var carousel = fragment.querySelector('scroll-carousel');
    var carouselId = 'clerk-recommendations-carousel-' + root.dataset.sectionId;

    carousel.id = carouselId;
    carousel.append.apply(carousel, cards);
    fragment.querySelectorAll('[aria-controls]').forEach(function (control) {
      control.setAttribute('aria-controls', carouselId);
    });

    return fragment;
  }

  function prepareSectionProducts(root, products) {
    var currentProductId = root.dataset.currentProductId || '';
    var seenProductIds = new Set();

    return products.filter(function (product) {
      var productId = product.id == null ? '' : String(product.id);

      if ((currentProductId && productId === currentProductId) || (productId && seenProductIds.has(productId))) {
        return false;
      }

      if (productId) {
        seenProductIds.add(productId);
      }

      return true;
    });
  }

  function renderProducts(root, products, data, content, trackClicks) {
    if (root.dataset.presentation === 'cart-drawer') {
      renderCartProducts(root, products, data, content, trackClicks);
      return;
    }

    products = prepareSectionProducts(root, products);

    var output = root.querySelector('[data-clerk-recommendations-output]');

    if (!output || products.length === 0) {
      root.hidden = true;
      return;
    }

    var contentFragment = document.createDocumentFragment();
    var header = createHeader(root, data, content);

    if (header) {
      contentFragment.appendChild(header);
    }

    contentFragment.appendChild(createProductList(root, products));
    output.replaceChildren(contentFragment);
    root.hidden = false;

    if (trackClicks) {
      window.Clerk('click', '#' + output.id + ' [data-clerk-product-id]');
    }
  }

  function renderRecommendations(content, data) {
    var source = content && content.element;

    if (!(source instanceof Element)) {
      return;
    }

    var root = source.closest('[data-clerk-recommendations]');

    if (!root) {
      return;
    }

    renderProducts(root, getProducts(data), data, content, true);
  }

  function renderDesignPreview(root) {
    var productsPerRow = Number(root.dataset.productsPerRowDesktop) || 4;
    var previewLimit = Math.max(8, productsPerRow * 2);
    var previewProducts = shuffleProducts(getPreviewProducts(root)).slice(0, previewLimit);
    var previewData = {
      headline: root.dataset.previewHeading || 'Anteprima raccomandazioni'
    };

    renderProducts(root, previewProducts, previewData, null, false);
  }

  function renderDesignPreviews(scope) {
    scope.querySelectorAll('[data-clerk-recommendations]').forEach(renderDesignPreview);
  }

  function initializeManualClerkContent(scope) {
    scope.querySelectorAll('[data-clerk-manual-content]').forEach(function (source) {
      if (!source.id) {
        return;
      }

      window.Clerk('content', '#' + window.CSS.escape(source.id));
    });
  }

  if (isDesignMode) {
    renderDesignPreviews(document);
    document.addEventListener('shopify:section:load', function (event) {
      renderDesignPreviews(event.target);
    });
    document.addEventListener('cart-drawer:refreshed', function (event) {
      renderDesignPreviews(event.target);
    });
    return;
  }

  loadClerk();

  window.Clerk('config', {
    key: clerkKey,
    visitor: getClerkVisitor(),
    observe_dom: true,
    formatters: {
      currency_converter: function (price) {
        var currencyRate = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
        return String(Number(price) * currencyRate);
      }
    },
    globals: {
      currency_iso: currency,
      currency_symbol: currencySymbol
    }
  });

  window.Clerk('on', 'rendered', '.clerk-recommendations__source', renderRecommendations);
  initializeManualClerkContent(document);

  document.addEventListener('cart-drawer:refreshed', function (event) {
    initializeManualClerkContent(event.target);
  });
})();
